import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { getToken, isTokenExpired } from '../utils/auth';

function UserSettings() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { themePreference, setTheme } = useTheme();

  useEffect(() => {
    if (!getToken() || isTokenExpired(0)) {
      navigate('/');
    }
  }, [navigate]);

  const options = [
    { value: 'system', label: t('theme_system'), icon: 'bi-circle-half' },
    { value: 'light',  label: t('theme_light'),  icon: 'bi-sun' },
    { value: 'dark',   label: t('theme_dark'),   icon: 'bi-moon-stars' },
  ];

  return (
    <div className="container py-4" style={{ maxWidth: 600 }}>
      <button className="btn btn-sm btn-light mb-3" onClick={() => navigate(-1)}>
        <i className="bi bi-arrow-left me-1"></i>{t('Back')}
      </button>
      <h4 className="mb-4">{t('Settings')}</h4>

      <div className="mb-2 border ez-rounded-tile ez-shadow p-3 bg-white">
        <div className="fw-semibold mb-3">{t('Appearance')}</div>
        <div className="d-flex gap-2">
          {options.map(({ value, label, icon }) => (
            <button
              key={value}
              onClick={() => setTheme(value)}
              className={`btn btn-sm flex-fill d-flex flex-column align-items-center gap-1 py-2 ${
                themePreference === value ? 'ez-button-full' : 'ez-button-light'
              }`}
            >
              <i className={`bi ${icon} fs-5`}></i>
              <span>{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default UserSettings;
